/* global chrome */

export const chromeSendMessage = (data) => {
  const callback = (response) => {
    if (chrome.runtime.lastError) {
      console.log("DEBUG INFO 16/07/2021 10:08", chrome.runtime.lastError)
    }
    if (response && !response.success) {
      console.log("error", response)
    }
  }

  chrome.runtime.sendMessage(
    "faoiadiiokmaphndfcmdbhlihimgpmck",
    data,
    {},
    callback
  )
  
  chrome.runtime.sendMessage(
    process.env.CHROME_EXTENSION_ID,
    data,
    {},
    callback
  )
}